import React, { useState } from "react";
import { FacilityCard } from "../Facilities/FacilityCard";
import { Col, Row, Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { resetState } from "../../../redux/actions/dbactions/exploreActions";
import { NewCalender } from "./NewCalender";
import NewDoctor from "./addDoctor"; // Import the NewDoctor form
import "./exploreCard.scss"; // Import the CSS file
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";
import PaymentSuccessModal from "../../../Modals/PaymentSuccessModal";
import PaymentFailedModal from "../../../Modals/PaymentFailedModal";

export const ExploreCrad = ({ exploreList, exploreService }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedID, setSelectedID] = useState(null);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility

  const handleCalenderOpen = (svcf_id) => {
    // Modify the function to accept additional data
    setOpen(true);
    setSelectedID(svcf_id);
  };

  const handleAddDoctor = () => {
    setShowModal(true); // Show the modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Hide the modal
  };

  const handleAgainExplore = () => {
    dispatch(resetState());
  };

  return (
    <div>
      <Header
        pageTitle={`Explore > ${exploreService}`}
        icon={<Icon icon="material-symbols:explore-outline" />}
      />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap">
          Facilities
        </h5>
        <div className="w-fit whitespace-nowrap flex items-center gap-1">
          <button onClick={handleAddDoctor} className="sign_btn !text-xs">
            Please add my Provider
          </button>
          <button onClick={handleAgainExplore} className="sign_btn !text-xs">
            Return To Explore
          </button>
        </div>
      </div>
      <Row className="m-0 sm:px-6">
        {exploreList.map((item) => (
          <Col className="mb-3" key={item.id} lg={4} md={6}>
            <FacilityCard
              handleCalenderOpen={() => handleCalenderOpen(item.svcf_id)}
              data={item}
              route={"explore"}
            />
          </Col>
        ))}
      </Row>
      <NewCalender
        selectedID={selectedID}
        show={open}
        onHide={() => setOpen(false)}
        dispatch={dispatch}
      />

      {/* Modal for Add Doctor */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <h5 className="mb-0">Please add this service provider</h5>
        </Modal.Header>
        <Modal.Body>
          <NewDoctor handleCloseModal={handleCloseModal} />
        </Modal.Body>
      </Modal>
    </div>
  );
};
